import {
  faBrain,
  faRobot,
  faSitemap,
  faVectorSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import awsLogo from '../images/icon/aws.svg';
import bootstrap from '../images/icon/bootstrap.png';
import cProgramming from '../images/icon/c-programming.png';
import chromeDev from '../images/icon/choromeDev.png';
import css from '../images/icon/css.png';
import dockerLogo from '../images/icon/docker.svg';
import expressjs from '../images/icon/expressjs.png';
import figma from '../images/icon/figma.png';
import firebase from '../images/icon/firebase.png';
import git from '../images/icon/Git.png';
import githubActionsLogo from '../images/icon/githubactions.svg';
import graphQL from '../images/icon/graphQL.png';
import html from '../images/icon/html.png';
import javascript from '../images/icon/js.png';
import jest from '../images/icon/jest.png';
import kubernetesLogo from '../images/icon/kubernetes.svg';
import material from '../images/icon/meta.png';
import mongodb from '../images/icon/mongodb.png';
import mongoose from '../images/icon/mongoose.png';
import mysql from '../images/icon/mysql.png';
import nestjsLogo from '../images/icon/nestjs.svg';
import nextjs from '../images/icon/nextjs.png';
import nodejs from '../images/icon/nodejs.png';
import npm from '../images/icon/npm.png';
import postgresqlLogo from '../images/icon/postgresql.svg';
import prismaLogo from '../images/icon/prisma.svg';
import python from '../images/icon/python.png';
import reactNative from '../images/icon/react-native.png';
import react from '../images/icon/react.png';
import redisLogo from '../images/icon/redis.svg';
import rtkQuery from '../images/icon/rtkQuery.png';
import redux from '../images/icon/redux.png';
import sass from '../images/icon/sass.png';
import soket from '../images/icon/soket.png';
import slack from '../images/icon/slack.png';
import styledComponents from '../images/icon/style-component.png';
import tailwind from '../images/icon/tailwind.png';
import terraformLogo from '../images/icon/terraform.svg';
import trello from '../images/icon/trello.png';
import typescript from '../images/icon/type_script.png';
import vscode from '../images/icon/vs-code.png';
import webpack from '../images/icon/webpack.png';
import wordpress from '../images/icon/wordpress.png';
import yarn from '../images/icon/yarn.png';
import './../index.css';

const SKILL_GROUPS = [
  {
    title: 'Frontend',
    skills: [
      { name: 'React.js', icon: react },
      { name: 'Next.js', icon: nextjs },
      { name: 'TypeScript', icon: typescript },
      { name: 'JavaScript', icon: javascript },
      { name: 'Redux Toolkit', icon: redux },
      { name: 'RTK Query', icon: rtkQuery },
      { name: 'React Native', icon: reactNative },
      { name: 'HTML 5', icon: html },
      { name: 'CSS 3', icon: css },
      { name: 'Tailwind', icon: tailwind },
      { name: 'Material UI', icon: material },
      { name: 'Styled Component', icon: styledComponents },
      { name: 'Bootstrap 5', icon: bootstrap },
      { name: 'Sass', icon: sass },
    ],
  },
  {
    title: 'Backend & Database',
    skills: [
      { name: 'Node.js', icon: nodejs },
      { name: 'NestJS', icon: nestjsLogo },
      { name: 'Express.js', icon: expressjs },
      { name: 'MongoDB', icon: mongodb },
      { name: 'Mongoose', icon: mongoose },
      { name: 'PostgreSQL', icon: postgresqlLogo },
      { name: 'Prisma', icon: prismaLogo },
      { name: 'Redis', icon: redisLogo },
      { name: 'MySQL', icon: mysql },
      { name: 'GraphQL', icon: graphQL },
      { name: 'Socket.IO', icon: soket },
      { name: 'Firebase', icon: firebase },
      { name: 'Python', icon: python },
      { name: 'C Programming', icon: cProgramming },
      { name: 'WordPress', icon: wordpress },
    ],
  },
  {
    title: 'DevOps & Cloud',
    skills: [
      { name: 'AWS', icon: awsLogo },
      { name: 'Docker', icon: dockerLogo },
      { name: 'Kubernetes', icon: kubernetesLogo },
      { name: 'Terraform (IaC)', icon: terraformLogo },
      { name: 'CI/CD (GitHub Actions)', icon: githubActionsLogo },
      { name: 'Microservices & Systems Design', faIcon: faSitemap },
      { name: 'AI/ML Integration', faIcon: faBrain },
      { name: 'RAG & Vector Search', faIcon: faVectorSquare },
      { name: 'LLM Agents (MCP)', faIcon: faRobot },
    ],
  },
  {
    title: 'Tools',
    skills: [
      { name: 'Git', icon: git },
      { name: 'Jest', icon: jest },
      { name: 'Webpack', icon: webpack },
      { name: 'NPM', icon: npm },
      { name: 'Yarn', icon: yarn },
      { name: 'VS Code', icon: vscode },
      { name: 'Chrome Dev Tools', icon: chromeDev },
      { name: 'Figma', icon: figma },
      { name: 'Trello', icon: trello },
      { name: 'Slack', icon: slack },
    ],
  },
];

const Skills = () => {
  return (
    <section
      className='skills-container'
      name='skills'
      id='skills'
      data-aos='zoom-in'
    >
      <div className='common my-5 pt-5'>
        <h2 className='mainHeader'>What I Am Good At</h2>
        <div className='commonBorder' />
      </div>

      {SKILL_GROUPS.map((group) => (
        <div className='skills-group' key={group.title}>
          <div className='d-flex justify-content-center mb-4'>
            <h3>{group.title}</h3>
          </div>
          <div className='skills-grid'>
            {group.skills.map((skill) => (
              <div className='skill-item' key={skill.name}>
                {skill.faIcon ? (
                  <FontAwesomeIcon
                    icon={skill.faIcon}
                    title={`${skill.name} icon`}
                    aria-label={`${skill.name} icon`}
                    className='skill-icon skill-icon-fa'
                  />
                ) : (
                  <img
                    src={skill.icon}
                    alt={`${skill.name} icon`}
                    className='skill-icon'
                  />
                )}
                <figcaption>{skill.name}</figcaption>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default Skills;
